import ExpandMore from '@mui/icons-material/ExpandMore'
import { Select, SelectChangeEvent } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { LanguageType, LangValue } from '../../..'
import { LanguageSelectProps } from '../../types'

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.variables.colors.accordionSummary.root
  }
}))

export const DesktopLanguageSelect = ({
  languageOptions,
  selectUILanguage,
  UILanguage
}: LanguageSelectProps) => {
  const classes = useStyles()

  const onLanguageChange = (event: SelectChangeEvent<LangValue>) => {
    selectUILanguage(event.target.value as LangValue)
  }

  return (
    <Select
      classes={{
        icon: classes.icon
      }}
      id="topbar-language-selection"
      native
      onChange={onLanguageChange}
      IconComponent={ExpandMore}
      inputProps={{
        name: 'lang',
        id: 'topbar-language-selection'
      }}
      value={UILanguage}
      variant="standard"
    >
      {languageOptions.map((language: LanguageType) => (
        <option
          aria-label={language.text}
          key={language.value}
          value={language.value}
        >
          {language.text}
        </option>
      ))}
    </Select>
  )
}
